import { z } from 'zod';

import { Option } from './Option';

export enum ComponentFileType {
    APPLICATION_NOTES = 'applicationNotes',
    CHARACTERISTICS = 'characteristics',
    DATASHEET = 'datasheet',
    DYNAMIC_CHARACTERISTICS = 'dynamicCharacteristics',
    INSTALLATION_MANUAL = 'installationManual',
    OTHER = 'other',
    OPERATIONAL_MANUAL = 'operationalManual',
    OUTPUT_IMPEDANCE_CHARACTERISTICS = 'outputImpedanceCharacteristics',
    QUICKSTART_GUIDE = 'quickstartGuide',
    USER_MANUAL = 'userManual',
    CERTIFICATE = 'certificate',
}

const componentFileTypeValidator = z.enum([
    ComponentFileType.APPLICATION_NOTES,
    ComponentFileType.CHARACTERISTICS,
    ComponentFileType.DATASHEET,
    ComponentFileType.DYNAMIC_CHARACTERISTICS,
    ComponentFileType.INSTALLATION_MANUAL,
    ComponentFileType.OTHER,
    ComponentFileType.OPERATIONAL_MANUAL,
    ComponentFileType.OUTPUT_IMPEDANCE_CHARACTERISTICS,
    ComponentFileType.QUICKSTART_GUIDE,
    ComponentFileType.USER_MANUAL,
    ComponentFileType.CERTIFICATE,
]);

const options = [
    {
        value: ComponentFileType.DATASHEET,
        label: 'Datasheet',
    },
    {
        value: ComponentFileType.USER_MANUAL,
        label: 'User Manual',
    },
    {
        value: ComponentFileType.INSTALLATION_MANUAL,
        label: 'Installation Manual',
    },
    {
        value: ComponentFileType.APPLICATION_NOTES,
        label: 'Application Notes',
    },
    {
        value: ComponentFileType.OPERATIONAL_MANUAL,
        label: 'Operational Manual',
    },
    {
        value: ComponentFileType.QUICKSTART_GUIDE,
        label: 'Quickstart Guide',
    },
    {
        value: ComponentFileType.CHARACTERISTICS,
        label: 'Characteristics',
    },
    {
        value: ComponentFileType.DYNAMIC_CHARACTERISTICS,
        label: 'Dynamic Characteristics',
    },

    {
        value: ComponentFileType.OUTPUT_IMPEDANCE_CHARACTERISTICS,
        label: 'Output Impedance Characteristics',
    },

    {
        value: ComponentFileType.CERTIFICATE,
        label: 'Certificate',
    },
    {
        value: ComponentFileType.OTHER,
        label: 'Other',
    },
] as Option<ComponentFileType>[];

export const ComponentFileTypes = {
    validator: componentFileTypeValidator,
    options,
};
